<template>
  <div :style="getRootStyle()" :class="getClass()">
    <div data-position="in" data-position1="header" :data-pc-key="config.key" :style="getHeaderStyle()" title="视图头部" v-if="properties.bodyPaddingTop > 0">
      <component v-if="header" :key="header.key" :is="header.configComponent" :endpoint="endpoint" :group="group" :config="header" dropMode="in" @remove="removeChild" ref="header"></component>
    </div>
    <div data-position="in" data-position1="center" :data-pc-key="config.key" :style="getCenterStyle()" title="视图中间可滚动区域">
      <component v-if="center" :key="center.key" :is="center.configComponent" :endpoint="endpoint" :group="group" :config="center" dropMode="in" @remove="removeChild" ref="center"></component>
    </div>
    <div data-position="in" data-position1="footer" :data-pc-key="config.key" :style="getFooterStyle()" title="视图底部" v-if="properties.bodyPaddingBottom > 0">
      <component v-if="footer" :key="footer.key" :is="footer.configComponent" :endpoint="endpoint" :group="group" :config="footer" dropMode="in" @remove="removeChild" ref="footer"></component>
    </div>
  </div>
</template>

<script>
import mixin from './mixin.js'

export default {
  name: 'mobile-view-box-component',
  mixins: [mixin],
  data () {
    return {
      header: null,
      center: null,
      footer: null,
      properties: {
        bodyPaddingTop: 0,
        bodyPaddingBottom: 0
      }
    }
  },
  methods: {
    getClass () {
      let clazz = 'pcd-mvb'
      if (this.dragOverPosition) {
        clazz += ` pcd-mvb-dragover`
      }
      if (this.selected) {
        clazz += ' pcd-mvb-selected'
      }
      return clazz
    },
    getRootStyle () {
      let style = ''
      if (this.properties.bodyPaddingTop > 0) {
        style += `padding-top:${this.properties.bodyPaddingTop}px;`
      }
      if (this.properties.bodyPaddingBottom > 0) {
        style += `padding-bottom:${this.properties.bodyPaddingBottom}px;`
      }
      return style
    },
    getHeaderStyle () {
      return `width:100%;height:${this.properties.bodyPaddingTop}px;position:absolute;top:0;left:0;background:#c1c1c1;overflow:auto;-webkit-overflow-scrolling:touch;`
    },
    getCenterStyle () {
      return 'width:100%;height:100%;overflow:auto;-webkit-overflow-scrolling:touch;'
    },
    getFooterStyle () {
      return `width:100%;height:${this.properties.bodyPaddingBottom}px;position:absolute;bottom:0;left:0;background:#c1c1c1;overflow:auto;-webkit-overflow-scrolling:touch;`
    },
    getChildren () {
      let children = []
      if (this.header) {
        children.push(this.header)
      }
      if (this.center) {
        children.push(this.center)
      }
      if (this.footer) {
        children.push(this.footer)
      }
      return children
    },
    setChildren (childrenParam) {
      let children = childrenParam || []
      for (let child of children) {
        if (child.extra === 'header') {
          this.header = child
        } else if (child.extra === 'footer') {
          this.footer = child
        } else if (child.extra === 'center') {
          this.center = child
        }
      }
    },
    addChild (config, index, e) {
      let position = e.target.getAttribute('data-position1')
      if (position === 'header') {
        config.extra = 'header'
        this.header = config
      } else if (position === 'footer') {
        config.extra = 'footer'
        this.footer = config
      } else {
        config.extra = 'center'
        this.center = config
      }
    },
    removeChild (component) {
      let child
      let extra = component.config.extra
      if (extra === 'header') {
        child = this.header
        this.header = null
      } else if (extra === 'footer') {
        child = this.footer
        this.footer = null
      } else {
        child = this.center
        this.center = null
      }
      return child
    },
    getChildComponents () {
      let result = []
      if (this.$refs.header) {
        result.push(this.$refs.header)
      }
      if (this.$refs.center) {
        result.push(this.$refs.center)
      }
      if (this.$refs.footer) {
        result.push(this.$refs.footer)
      }
      return result
    }
  }
}
</script>

<style>
.pcd-mvb{position:absolute;top:-1px;right:-1px;left:-1px;bottom:-1px;border:1px dashed transparent;box-sizing:border-box;cursor:pointer;background:#999;}
.pcd-mvb-dragover{border-color:red;}
.pcd-mvb-selected{border-color:blue;border-style:solid;}
.pcd-mvb>div>div{margin:0;border:0;}
.pcd-mvb>div>div.pcd-component-selected{border:1px solid #409EFF;}
</style>
